import React from 'react';
import ReactGoogleMap from './ReactGoogleMap';

const ContactMap = () => {
  return (
    <section id="contact-map">
      
      <h1>Telephely</h1>

      <address>
        5310 Kisújszállás Kossuth L. U. 74.
      </address>

      <ReactGoogleMap />

    </section>
  );
};

export default ContactMap;